/*
Scroll linked ground colour.

One fixed layer behind the page. Each beat boundary tweens the layer from the
previous beat's colour to its own, so the background changes as a gradient
across the boundary instead of a hard cut. Without motion the sections paint
their own grounds and the page reads the same, with hard edges.

Each boundary declares both of its colours. This is the whole reason the module
works in both directions.

gsap.to() would record its start value the first time it renders. Several
tweens then drive one property on one element, and the recorded value can be the
colour of a different beat, captured part way through another transition. A
ScrollTrigger.refresh() re-records it, and refreshOnFontLoad() in main.js calls
one after the fonts load. Scrolling back up then returned the layer to whatever
had been recorded rather than to the beat above. fromTo() states both ends, so
the boundary gives the same colours whichever way it is crossed, and a refresh
cannot change them.
*/

export function ground(gsap) {
  const layer = document.querySelector('.ground');
  const beats = gsap.utils.toArray('[class*="beat-"]');

  if (!layer || !beats.length) return;

  const surfaceOf = (el) => getComputedStyle(el).getPropertyValue('--surface').trim();
  const colours = beats.map(surfaceOf);

  layer.style.backgroundColor = colours[0];

  beats.forEach((beat, i) => {
    /* The first beat is the starting colour, so it has no boundary above it. */
    if (i === 0) return;

    const from = colours[i - 1];
    const to = colours[i];

    if (!from || !to) return;

    gsap.fromTo(
      layer,
      { backgroundColor: from },
      {
        backgroundColor: to,
        ease: 'none',
        /* Do not paint on load. The boundary owns the colour only while crossed. */
        immediateRender: false,
        scrollTrigger: {
          trigger: beat,
          start: 'top 62%',
          end: 'top 18%',
          scrub: 0.6,
        },
      }
    );
  });
}
